import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UserDataBaseApi {
  constructor(private _http: HttpClient) {}

  sync$(id: string) {
    return this._http.put<any>(
      `/api/service-stack/${id}/sync-user-data`,
      {}
    );
  }

  updateSecretEnvs$(serviceStackId: string, envFile: string, sensitive?: boolean) {
    return this._http.put<any>(
      `/api/service-stack/${serviceStackId}/user-data/env-file`,
      { envFile, sensitive }
    );
  }

  revealUserData$(id: string) {
    return this._http.get<{ content: string; }>(
      `/api/user-data/${id}/reveal`
    );
  }

  // Bulk-reveal endpoint: returns every user-defined env of the requested category
  // (sensitive or not) pre-serialized as a round-trippable `.env` string. Sudo is
  // required only when `sensitive=true`; the same value must be sent back to the PUT.
  getUserDataEnvFile$(serviceStackId: string, sensitive?: boolean) {
    return this._http.get<{ envFile: string; }>(
      `/api/service-stack/${serviceStackId}/user-data/env-file`,
      { params: { sensitive: `${!!sensitive}` } }
    );
  }

}
